import ReactDom from 'react-dom';

function renderer(component, element) {
  return ReactDom.render(component, element);
}

export default renderer;
